module.exports = __webpack_public_path__ + "img/logo-lincolntech.d2ed4e84.svg";